import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { FORM_CUPO } from '../../../config/forms'
import DialogView from '../../Dialogos/DialogView'
import BloqueoDeCuposDialogView from './BloqueDeCuposDialogView'

const selector = formValueSelector(FORM_CUPO)

const BloqueoDeCuposDialog = (props) => {
  const { confirmCallback, cancelCallback } = props

  return (
    <DialogView
      confirmCallback={confirmCallback}
      cancelCallback={cancelCallback}
      title='Bloqueo de cupos'
      content={
        <BloqueoDeCuposDialogView />
      }
    />
  )
}

const mapStateToProps = state => {
  return {
    bloqueoTotal: selector(state, 'bloqueoTotal'),
    cereal: selector(state, 'cereal'),
    exportador: selector(state, 'exportador')
  }
}

export default (connect(mapStateToProps))(BloqueoDeCuposDialog)
